import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const FilterSearch = ({ searchTerm, onSearchChange, placeholder = "Search filters..." }) => {
  return (
    <InputGroup className="mb-3">
      <InputGroup.Text>
        🔍
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </InputGroup>
  );
};

export default FilterSearch;